export default "__VITE_ASSET__ZuCLc$1i__"